import { Component, Input } from "@angular/core";
import { UpsellStep } from "src/app/models/upsellStep";

@Component({
    selector: "upsell-steps",
    templateUrl: "upsell-steps.html",
    styleUrls: ["upsell-steps.scss"],
})

export class UpsellStepsComponent {
  @Input() steps: UpsellStep[] = [];
  @Input() stepLabel: string = 'step';

  constructor() {}

  trackByFn(index: number, item: UpsellStep): string | number {
    return item?.id || index;
  }
}
